import { useEffect, useState } from "react";
import { UsersIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { useStorage } from "../../hooks/useLocalStorage";

const navigation = [
  {
    name: "Account",
    icon: UsersIcon,
    children: [
      { name: "Account Information", href: "/user/profile" },
      { name: "Change Password", href: "/user/change-password" },
      { name: "Course Information", href: "/user/course" },
      { name: "Forums", href: "/user/Forums" },
      { name: "Transaction History", href: "/user/order-history" },
      { name: "Refund a Payment", href: "/user/Refund" },
    ],
  },
];

  // {
  //   name: "",
  //   icon: UsersIcon,
  //   current: false,
  //   children: [{ name: "Đơn hàng", href: "/user/order-history" }],
  // },


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function ComHeaderUser({ children }) {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(null);
 const [user, setUser, loadUser] = useStorage("use", null);
  useEffect(() => {
    setActiveCategory(currentPath);
    window.scrollTo(0, 0);
    loadUser();
    if (!user.id) {
      navigate("/login");
    }
  }, [currentPath]);

  return (
    <div className="max-w-[1400px] m-auto px-4">
      <div className="flex flex-col lg:flex-row w-full mt-2 gap-4">
        <div className="w-full lg:w-60">
          <div className="flex grow flex-col gap-y-5 overflow-y-auto px-4 pb-3 pt-5 bg-white mt-4 border border-gray-200 rounded-lg shadow-xl">
            <div className="flex h-16 gap-2 shrink-0 items-center justify-center">
              <img
                alt="Your Company"
                src={user.avatar}
                className="h-16 w-16 rounded-full"
              />
              <span className="text-sm lg:text-base">{user.firstName}</span>
            </div>
            <nav className="flex flex-1 flex-col">
              <ul role="list" className="flex flex-1 flex-col gap-y-7">
                {navigation.map((item) => (
                  <li key={item.name}>
                    <Disclosure as="div" defaultOpen={true}>
                      {({ open }) => (
                        <>
                          <DisclosureButton
                            className={classNames(
                              "group flex w-full items-center gap-x-3 rounded-md p-2 text-left text-sm font-semibold leading-6 text-gray-700",
                              item.children
                                ? "hover:bg-gray-50 hover:text-[#002278]"
                                : ""
                            )}
                          >
                            <ChevronRightIcon
                              className={`h-5 w-5 shrink-0 text-gray-400 transition-transform duration-200 ${
                                open ? "rotate-90" : ""
                              }`}
                            />
                            <item.icon
                              aria-hidden="true"
                              className="h-6 w-6 shrink-0"
                            />
                            {item.name}
                          </DisclosureButton>
                          <DisclosurePanel as="ul" className="mt-1">
                            {item.children.map((subItem) => (
                              <li key={subItem.name}>
                                <Link
                                  to={subItem.href}
                                  className={classNames(
                                    subItem.href === activeCategory
                                      ? "text-[#002278]"
                                      : "hover:text-[#002278] text-black",
                                    "block rounded-md py-2 pl-9 pr-2 text-sm leading-6 my-2"
                                  )}
                                >
                                  {subItem.name}
                                </Link>
                              </li>
                            ))}
                          </DisclosurePanel>
                        </>
                      )}
                    </Disclosure>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>

        <section className="flex-1 w-full">
          <div className="grid grid-cols-1 gap-4">
            <div className="w-full">
              <div>{children}</div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
